/* eslint-disable tree-shaking/no-side-effects-in-initialization */
/**
 * The purpose of this component is to define a common router interface
 * specially for the shared modules that need to be used in apps with
 * react-router and next/router.
 */
import React, {createContext} from 'react'
import PropTypes from 'prop-types'

const RouterContext = createContext()

const RouterProvider = ({push, replace, pathname, routeName, query, children}) =>
  <RouterContext.Provider value={{push, replace, pathname, routeName, query}}>
    {children}
  </RouterContext.Provider>

RouterProvider.propTypes = {
  push: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object
}

export {RouterContext}

export default RouterProvider
